const StockLocatorList = {
    countInRow:1,

    init() {
        this.el = $('[module="stock_locator"] [block="list"]');
        if (!this.el.length) return;

        this.hasFilter = !this.el.is('.no-filter');
        this.cars = this.el.find('.car');
        this.copyBtn = this.el.find('.vin span');
        this.resize();
        this.bind();
    },

    bind(){
        this.copyBtn.click((evt)=>{
            evt.stopPropagation();
            this.copy($(evt.currentTarget));
            return false;
        })
    },

    copy(button){
        navigator.clipboard.writeText(button.text().trim()).then(r => {
            setTimeout(() => {
                button.parent().addClass('done');
            }, 100)

            setTimeout(() => {
                button.parent().removeClass('done');
            }, 1500)
        });
    },

    setAnimation(cars) {
        cars.each((i, el)=>{
            const time = (i % this.countInRow) * 200;
            $(el).attr('data-aos-delay', time)
        })
    },

    resize() {
        if (!this.el || !this.el.length) return;
        const screen = window.innerWidth;

        if(this.hasFilter) {
            if (screen > 1330) this.countInRow = 3;
            else if (screen < 1330 && screen > 1000) this.countInRow = 2;
            else if (screen < 1000 && screen > 840) this.countInRow = 3;
            else if (screen < 840 && screen > 580) this.countInRow = 2;
            else if (screen < 580) this.countInRow = 1;
        } else {
            if (screen > 1330) this.countInRow = 4;
            else if (screen < 1330 && screen > 840) this.countInRow = 3;
            else if (screen < 840 && screen > 580) this.countInRow = 2;
            else if (screen < 580) this.countInRow = 1;
        }

        this.setAnimation(this.el.find('.car'));
    },

}

export default StockLocatorList;